module.exports = __webpack_public_path__ + "static/media/topbar-bg.eef71d63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topbar-bg.jpg
// module id = 1462
// module chunks = 110